import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import React, { useEffect, useState } from 'react';
import { ChevronRight } from '@mui/icons-material';
import { getCurrentProject } from '../../modules/project';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';


const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isSmallScreen' && prop !== 'drawerWidth' && prop !== 'type',
})(({ theme, open, type, isSmallScreen, drawerWidth }) => ({
  '& .MuiDrawer-paper': {
    position: 'fixed',
    top: 64,
    left: 0,
    height: 'calc(100vh - 64px)',
    whiteSpace: 'nowrap',
    width: (() => {
      if (type === 'documentation') return 250;
      if (isSmallScreen) return open ? drawerWidth : 0;
      return open ? drawerWidth : theme.spacing(7);
    })(),    
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: open
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: open ? 'auto' : 'hidden',
    ...(open
      ? {
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }
      : {
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7),
          },
        }),
  },
}));

export default function Sidebar({ MainListItems, open, toggleDrawer, type, isSmallScreen, drawerWidth, onSidebarNavigate }) {
  const projectId = useParams().projectId;
  const [currentProject, setCurrentProject] = useState(null);
  const [lastProjectName, setLastProjectName] = useState('');

  useEffect(() => {
  const fetch = async () => {
    if (projectId) {
      const response = await getCurrentProject(projectId);
      setCurrentProject(response);
      setLastProjectName(response?.name || '');
    }
  };
  fetch();
  }, [projectId]);
  return (
    <Drawer
      variant="permanent"
      open={open}
      type={type}
      drawerWidth={drawerWidth}
      isSmallScreen={isSmallScreen}
      sx={{
        mt: '64px',
        backgroundColor: '#fff',
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          my: 2,
          p: 1,
          width: '100%',
        }}>
        {open && (
          <>
            <Typography
              variant="subtitle1"
              color="text.primary"
              sx={{
                pl: 1,
                whiteSpace: 'break-spaces',
                lineHeight: '1.5rem',
                fontWeight: 600,
                textAlign: 'left',
              }}>
              {currentProject?.name || lastProjectName}
            </Typography>
          </>
        )}

        <>
          {type === 'dashboard' ? (
            open ? (
              <ChevronLeftIcon
                sx={{
                  backgroundColor: '#1b3f87',
                  color: '#ffffff',
                  borderRadius: '50%',
                  right: 2,
                  cursor: 'pointer',
                }}
                onClick={toggleDrawer}
              />
            ) : (
              <p className="p-2">
                <ChevronRight onClick={toggleDrawer} sx={{backgroundColor: '#1b3f87',
                  color: '#ffffff', borderRadius: '50%', cursor: 'pointer' }} />
              </p>
            )
          ) : null}
        </>
      </Box>

      <Divider />
      <List component="nav" sx={{ padding: 0 }}>
        <MainListItems
          projectId={projectId}
          open={open}
          type={type}
          showIcons={type !== 'documentation' && !(isSmallScreen && open)}
          onSidebarNavigate={onSidebarNavigate}
        />
        <Divider sx={{ my: 1 }} />
      </List>
    </Drawer>
  );
}
